/**
 @ngdoc service
 @name mapHistoryExtensionTileService
 @description
 factory used by mapTilesJsonData.js to construct tile data into tileData object
 */

(function() {
    'use strict';

    var mapHistoryScreeningCandidateTileService = function(tileDataFactory) {
        // Setting used field keys, to ignore when adding rest of fields to columns
        var usedFieldKeys = [].concat(tileDataFactory.HISTORY_TILE.COMMON_USED_FIELD_LIST);

        var map = function(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData){
            var self = this;
            // Assigning tile factory function with parameters to variable
            var tileFactory = new tileDataFactory.constructTileData(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData);

            tileFactory.addHistoryTimeStamp(tileFactory.historyTimeStamp.newHistoryTimeStamp('occurredOn'));
            tileFactory.addAllFieldsWithLabels(rawTileData, objectTilesLabels, usedFieldKeys, tileDataFactory.HISTORY_TILE.PRIORITY_LIST);

            return tileFactory.tileData;
        };

        return {
            map : map
        };
    };

    mapHistoryScreeningCandidateTileService.$inject = ['tileDataFactory'];
    angular.module('app').factory('mapHistoryScreeningCandidateTileService', mapHistoryScreeningCandidateTileService);
}());